import { useRef, useState } from 'react';
import type { IVideo } from '../shared/types';

/**
 * A hook that handles video autoplay logic
 * @param video Video object
 * @param disableAutoplay explicit disable
 * @returns
 */
export default function useVideoAutoplay(video: IVideo, disableAutoplay = false) {
    const { autoplayVideos } = video;
    const [currentVideo, setCurrentVideo] = useState<IVideo>(video);
    const hasAutoplayVideos = autoplayVideos?.length;
    const shouldAutoplay = !disableAutoplay && hasAutoplayVideos;
    const autoplayIndex = useRef(0);

    /* Methods */
    const getNextAutoplayVideo = () => {
        if (!shouldAutoplay) return null;

        const nextVideo = autoplayVideos[autoplayIndex.current];

        if (!nextVideo) return null;

        return nextVideo;
    };

    const playNextVideo = () => {
        if (shouldAutoplay) {
            const nextVideo = getNextAutoplayVideo();

            if (nextVideo) {
                setCurrentVideo(nextVideo);
                autoplayIndex.current += 1;
            }
        }
    };

    return {
        currentVideo,
        playNextVideo,
        getNextVideo: getNextAutoplayVideo
    };
}
